import React from "react";
import { useParams } from 'react-router-dom';
import SVILoading from './../component/sviLoading';
import { apiReviews } from './../api/apiReviews';
import { exceptionHandler } from './../helper/helperException';

export default function PageUnsubscribe() {
    const { guid } = useParams()
    const [unsubscribe, setUnsubscribe] = React.useState(undefined);

    React.useEffect(() => {
        if (guid === undefined ||
            guid === null ||
            guid === "" ||
            guid === "undefined" ||
            guid === "null" ||
            guid === "empty"
        ) {
            exceptionHandler(null, "PageUnsubscribe: Invalid GUID for unsubscribe", { guid: guid })
            setUnsubscribe(false);
            return;
        }

        try {
            apiReviews.unsubscribe({ guid })
                .then(_res => { setUnsubscribe(true); })
                .catch(ex => {
                    setUnsubscribe(false);
                    exceptionHandler(ex, "PageUnsubscribe: Error during unsubscribe", { guid: guid });
                });
        }
        catch (ex2) {
            exceptionHandler(ex2, "PageUnsubscribe: Error during unsubscribe2", { guid: guid });
        }
    }, [guid]);

    // Show loading state
    if (unsubscribe === undefined) return <SVILoading />;

    return (
        <main className="container">
            <div className="row text-center">
                <section className="vh-100 d-flex justify-content-center align-items-center">
                    {unsubscribe === false &&
                        <div>
                            <h3 className="text-danger">Unsubscribe failed!</h3>
                            <div className="mt-2">We are unable to unsubscribe you from our mailing list.</div>
                            <div>Please try again later.</div>
                        </div>
                    }
                    {unsubscribe === true &&
                        <div>
                            <h3 className="">Unsubscribe successful!</h3>
                            <div className="mt-2">You have been unsubscribed from our mailing list.</div>
                            <div>Thank you for your time.</div>
                        </div>
                    }
                </section>
            </div>
        </main>
    )
}
